export default "__VITE_ASSET__CxesjTET__"